import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AssistChip, Stack, Text } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IApiLegalDocument } from '~/lib/api/modules/LegalDocuments';
import { Table } from '~/components/molecules/Table';
import { LegalDocumentListItemMenu } from './LegalDocumentListItemMenu';

export type ILegalDocumentListItemProps = {
  legalDocument: IApiLegalDocument;
};

export const LegalDocumentListItem: React.FC<ILegalDocumentListItemProps> = (
  props,
) => {
  const { legalDocument } = props;
  const { t } = useTranslation();

  return (
    <Table.Row>
      <Stack
        as={Table.BodyAction}
        horizontal
        gap={3}
        href={`/apps/${legalDocument.appId}/settings/legalDocuments/${legalDocument._id}`}
      >
        <Stack gap={1}>
          {legalDocument.title ? (
            <Text variant="title" size="sm" truncate>
              {legalDocument.outdated ? (
                <s>{legalDocument.title}</s>
              ) : (
                legalDocument.title
              )}
            </Text>
          ) : null}
          {legalDocument.outdated ? (
            <Text variant="body" size="sm" dimmed>
              {t('LegalDocumentListItem.outdated')}
            </Text>
          ) : null}
        </Stack>
      </Stack>

      <Table.Body>
        {legalDocument.required ? <FontAwesomeIcon icon={faCheck} /> : null}
      </Table.Body>

      <Stack as={Table.Body} horizontal gap={2}>
        <AssistChip
          label={
            legalDocument.type === 'privacy'
              ? t('LegalDocumentListItem.type.privacy')
              : t('LegalDocumentListItem.type.tos')
          }
        />
      </Stack>

      <Stack as={Table.Body} horizontal justify="end">
        <LegalDocumentListItemMenu legalDocument={legalDocument} />
      </Stack>
    </Table.Row>
  );
};
